import { Component, OnInit } from '@angular/core';
import {AllCommunityModules} from '@ag-grid-community/all-modules';
// import {AllModules} from '@ag-grid-enterprise/all-modules';
import { HttpClient } from '@angular/common/http';
import '@ag-grid-community/all-modules/dist/styles/ag-grid.css';
import '@ag-grid-community/all-modules/dist/styles/ag-theme-balham-dark.css';
import { RouterLinkCellRendererComponent } from '../../router-link-cell-renderer/router-link-cell-renderer.component';
import {environment} from '../../../environments/environment';
import { map } from 'rxjs/operators';
import {BreadcrumbSupport, IBreadcrumbItem, IBreadcrumbSupport} from '../../breadcrumb/interfaces';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-acord-summary',
  templateUrl: './acord-summary.component.html',
  styleUrls: ['./acord-summary.component.scss']
})
export class AcordSummaryComponent extends BreadcrumbSupport implements OnInit {

    defaultColumDefs = {
      resizable: true,
      sortable: true,
      filter: true
    };

    columnDefs = [
      {headerName: 'Insured Name', field: 'insured', width: 200},
      {headerName: 'Submission Date', field: 'submission-date', width: 200},
      {headerName: 'Submission Number', field: 'submission-number', maxWidth: 150},
      {headerName: 'Score Date', field: 'score-date', width: 200},
      {headerName: 'Rank', field: 'rank', width: 50},
      {headerName: 'Loss History', field: 'losshistory', sortable: false, filter: false,
        width: 120, maxWidth: 120, valueFormatter: this.YesNoFormatter,
        cellStyle: {textAlign: 'center'}, headerStyle:{textAlign: 'center'} }
    ];

    frameworkComponents = {
      routerRenderer: RouterLinkCellRendererComponent
    };
    rowData: any;
    gridApi: any;
    gridColumnApi: any;
    fetchSubscription: Subscription;


    modules = AllCommunityModules;
    // modules = AllModules;

  constructor(private http: HttpClient, private router: Router) {
    super();
  }

  ngOnInit() {
    const url = window.location.origin +  '/api/uw/wc/get-acord-submissions?from-date=2019-10-01&thru-date=2025-12-31';
    this.fetchSubscription = this.http.get(url).subscribe((data: any[]) => {
      this.rowData = data;
    });
  }


  onGridReady(event) {
    this.gridApi = event.api;
    this.gridColumnApi = event.columnApi;
    this.gridApi.sizeColumnsToFit();
  }
  createBreadcrumbs(): IBreadcrumbItem[] {
    console.log('here');
    return [];
  }

  YesNoFormatter(params: any) {

    if (params.data.newVenture) {
      return 'New Venture'
    }

    if (params.value !== null) {
      return params.value ? 'Yes' : 'No';
    } else {
      return params.value;
    }
  }
  onRowClicked(event) {
    this.router.navigate(['/uw/acord/' + event.data['rts-link']]);
  }

}
